// extracted by mini-css-extract-plugin
export default {"iframe":"KadoWidget_iframe__s+r+m"};